import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/手机框.png'


const _withScopeId = n => (_pushScopeId("data-v-4deae575"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zone-mgmt-question-preview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "phone",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "preview" }
const _hoisted_4 = ["src"]

import { withDefaults, computed } from 'vue';
import { useTempWebviewTaskUrl } from '@hooks/webview';
import { ProjectType } from '@cTypes/project';


export default /*#__PURE__*/_defineComponent({
  __name: 'question-preview',
  props: {
    tempId: {},
    projectType: {}
  },
  setup(__props: any) {

const props = __props;

// C端预览地址
const ifrSrc = computed(() => {
  return useTempWebviewTaskUrl({
    tempId: props.tempId,
    projectType: props.projectType
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("iframe", {
        id: "iframe",
        src: ifrSrc.value,
        frameborder: "0",
        scrolling: "no",
        width: "375px",
        height: "670px"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})